export const btnVariants = {
  hover: {
    scale: 1.2,
  },
  click: {
    scale: 0.8,
  },
  leftSlideInInitial: {
    x: "-50vw",
  },
  leftSlideIn: {
    x: 0,
  },
  rightSlideInInitial: {
    x: 200,
  },
  rightSlideIn: {
    x: 0,
  },
};

export const iconVariants = {
  hover: {
    scale: 1.1,
  },
  click: {
    scale: 0.9,
  },
};

export const slideIn = {
  leftSlideInInitial: {
    x: "-85vw",
  },
  leftSlideIn: {
    x: 0,
  },
};

export const fadeIn = {
  visible: {
    opacity: 1,
    scale: 1,
  },

  hidden: {
    opacity: 1,
    scale: 0,
  },
};
